import {
  YStack,
  SizableText,
  Separator,
  shadowStandard,
  colors,
  Box,
  ScrollView,
  isWeb,
  XStack,
  SmartLink,
} from '@my/ui'
import { GroupCreationFormData } from './use-group-creation-wizard'
import { GroupCreationHeader } from './group-creation-header'
import { CheckCircle, Share2 } from '@tamagui/lucide-icons'
import { GroupAvatar } from 'app/features/group/components'
import { ShareContent } from 'app/features/sharing/components'
import { useShare } from 'app/features/sharing/hooks'

type GroupCreationShareProps = {
  data: GroupCreationFormData
  error?: string
  shareUrl: string
  groupId: string
  onClose: () => void
  toastController: any
}

export const GroupCreationShare = (props: GroupCreationShareProps) => {
  const profileImage = props.data.profileImage?.uri

  const { onShare } = useShare({
    href: props.shareUrl,
    subject: props.data.name,
  })

  return (
    <YStack gap="$3.5" flex={1} w="100%" {...props}>
      <GroupCreationHeader title="Invite people" onClose={props.onClose} w="100%" />

      <Separator boc="$overlay8" />

      <ScrollView contentContainerStyle={{ gap: 32, alignItems: 'center' }}>
        <YStack pt="$3.5" gap="$3.5" jc="center" ai="center">
          <YStack
            w={56}
            h={56}
            flexGrow={0}
            br={1000}
            p="$2.5"
            jc="center"
            ai="center"
            bg="$white"
            {...shadowStandard}
          >
            <CheckCircle color={colors.primary} width={36} height={36} />
          </YStack>
          <SizableText ta="center" size="$8" fow="600">
            Your Group has been Published, you can now Invite people!
          </SizableText>
        </YStack>

        <SmartLink
          Component={Box}
          gap="$3.5"
          flexGrow={0}
          href={`/groups/${props.groupId}`}
          onPress={props.onClose}
        >
          <GroupAvatar src={profileImage} width={44} height={44} />
          <SizableText size="$6" fow="600">
            {props.data.name}
          </SizableText>
        </SmartLink>

        {!isWeb && (
          <XStack jc="center" ai="center" gap="$3.5">
            <YStack
              cursor="pointer"
              tag="button"
              gap="$2"
              ai="center"
              jc="center"
              onPress={onShare}
              hoverStyle={{ opacity: 0.7 }}
              pressStyle={{ opacity: 0.7 }}
              focusStyle={{ opacity: 0.7 }}
            >
              <YStack
                w={56}
                h={56}
                flexGrow={0}
                br={1000}
                p="$2.5"
                jc="center"
                ai="center"
                bg="$white"
                {...shadowStandard}
              >
                <Share2 color={colors.black} width={24} height={24} />
              </YStack>
              <SizableText ta="center" size="$4" color="$overlay10">
                Share via
              </SizableText>
            </YStack>
          </XStack>
        )}

        {isWeb && <ShareContent href={props.shareUrl} subject={props.data.name} />}
      </ScrollView>
    </YStack>
  )
}
